import { Typography } from "@mui/material"
import { Stack } from "src/shared/components"

const InvoiceInfoRow = ({
  title,
  value,
  justifyContent = "space-between"
}: {
  title: string
  value: string
  justifyContent?: "flex-start" | "flex-end" | "center" | "space-between"
}) => {
  return (
    <Stack direction="row" spacing={1} justifyContent={justifyContent}>
      <Typography color="var(--slipColor)" variant="body2" fontWeight={600}>
        {title}
      </Typography>
      <Typography color="var(--slipColor)" variant="body2">
        {value}
      </Typography>
    </Stack>
  )
}

export default InvoiceInfoRow
